/* Limavia — Calcetines de compresion. Landing behaviour.
   Never touches the cart: the native <product-form> owns Add to Cart. */
(function () {
  'use strict';

  var ready = function (fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  };

  /* ---------- generic collapse (hero accordions + FAQ), via delegation ---------- */
  function bindCollapse() {
    document.addEventListener('click', function (e) {
      var head = e.target.closest('.ccl-acc__head, .ccl-fq__head');
      if (!head) return;
      var item = head.closest('.ccl-acc, .ccl-fq');
      if (!item) return;
      var open = item.classList.contains('is-open');
      var group = item.parentElement;
      if (group) {
        group.querySelectorAll('.ccl-acc.is-open, .ccl-fq.is-open').forEach(function (el) {
          if (el !== item) {
            el.classList.remove('is-open');
            var h = el.querySelector('.ccl-acc__head, .ccl-fq__head');
            if (h) h.setAttribute('aria-expanded', 'false');
          }
        });
      }
      item.classList.toggle('is-open', !open);
      head.setAttribute('aria-expanded', String(!open));
    });
  }

  /* ------------------------------ gallery ------------------------------ */
  function initGallery(root) {
    var track = root.querySelector('.ccl-gallery__track');
    if (!track) return;
    var slides = root.querySelectorAll('.ccl-gallery__slide');
    var thumbs = root.querySelectorAll('.ccl-thumb');
    var count = root.querySelector('.ccl-gallery__count');
    var total = slides.length;
    if (!total) return;

    function current() {
      var w = track.clientWidth || 1;
      return Math.min(total - 1, Math.max(0, Math.round(track.scrollLeft / w)));
    }
    function sync() {
      var i = current();
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      if (count) count.textContent = (i + 1) + ' / ' + total;
    }
    function go(i) {
      var n = ((i % total) + total) % total;
      track.scrollTo({ left: track.clientWidth * n, behavior: 'smooth' });
    }

    root.addEventListener('click', function (e) {
      var prev = e.target.closest('.ccl-gnav--prev');
      var next = e.target.closest('.ccl-gnav--next');
      var th = e.target.closest('.ccl-thumb');
      if (prev) { go(current() - 1); return; }
      if (next) { go(current() + 1); return; }
      if (th) {
        var idx = Array.prototype.indexOf.call(thumbs, th);
        if (idx > -1) go(idx);
      }
    });

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });

    sync();
  }

  /* --------------------------- size guide modal --------------------------- */
  function bindModal() {
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-ccl-size-open]');
      if (open) {
        var id = open.getAttribute('data-ccl-size-open');
        var m = document.getElementById(id);
        if (m) { m.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
        return;
      }
      var close = e.target.closest('[data-ccl-size-close]');
      if (close) {
        var mm = close.closest('.ccl-modal');
        if (mm) { mm.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.ccl-modal.is-open').forEach(function (m) {
        m.classList.remove('is-open');
      });
      document.documentElement.style.overflow = '';
    });
  }

  /* ---------------------------- reviews show more ---------------------------- */
  function bindShowMore() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ccl-more]');
      if (!btn) return;
      var grid = document.getElementById(btn.getAttribute('data-ccl-more'));
      if (!grid) return;
      var expanded = btn.getAttribute('data-expanded') === 'true';
      grid.querySelectorAll('.ccl-rcard').forEach(function (c, i) {
        if (i >= Number(btn.getAttribute('data-visible') || 4)) c.classList.toggle('is-hidden', expanded);
      });
      btn.setAttribute('data-expanded', String(!expanded));
      btn.textContent = expanded
        ? (btn.getAttribute('data-more-label') || 'Mostrar más reseñas')
        : (btn.getAttribute('data-less-label') || 'Mostrar menos');
    });
  }

  /* ------------------------------- carousel ------------------------------- */
  function bindCarousel() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ccl-carousel-next]');
      if (!btn) return;
      var track = document.getElementById(btn.getAttribute('data-ccl-carousel-next'));
      if (!track) return;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      if (atEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: track.clientWidth * 0.85, behavior: 'smooth' });
    });
  }

  /* ------------------------------ sticky bar ------------------------------ */
  function initSticky() {
    var bar = document.querySelector('.ccl-sticky');
    if (!bar) return;
    var anchor = document.getElementById('ccl-buy-anchor');
    var now = bar.querySelector('.ccl-sticky__now');
    var was = bar.querySelector('.ccl-sticky__was');

    // never visible on load
    bar.classList.remove('is-visible');

    var footer = document.querySelector('footer, .footer, #shopify-section-footer, [id*="footer"]');

    function update() {
      var doc = document.documentElement;
      var scrolled = window.scrollY || doc.scrollTop || 0;
      var half = (doc.scrollHeight - window.innerHeight) * 0.4;
      var past = scrolled > Math.max(half, 400);
      if (anchor) {
        var r = anchor.getBoundingClientRect();
        past = past || r.bottom < 0;
      }
      var overFooter = false;
      if (footer) {
        var fr = footer.getBoundingClientRect();
        overFooter = fr.top < window.innerHeight - 20;
      }
      bar.classList.toggle('is-visible', past && !overFooter);
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();

    // mirror whatever price the buy area shows (Kaching may rewrite it)
    var src = document.querySelector('[data-ccl-price-source]');
    if (src && now) {
      var clean = function (s) { return (s || '').replace(/\s+/g, ' ').trim(); };
      var mirror = function () {
        // priority order matters: a selector LIST would return the first node in DOM
        // order, which is the struck-through compare-at price.
        var saleEl = src.querySelector('.price-item--sale')
          || src.querySelector('.price__sale .price-item:not(.price-item--regular)')
          || src.querySelector('.price__regular .price-item');
        var txt;
        if (saleEl) {
          txt = clean(saleEl.textContent);
        } else {
          var clone = src.cloneNode(true);
          clone.querySelectorAll('s, del, .price-item--regular, .price__compare, .ccl-save')
            .forEach(function (n) { n.remove(); });
          txt = clean(clone.textContent);
        }
        if (txt) now.textContent = txt;
        if (was) {
          var cmpEl = src.querySelector('s') || src.querySelector('del')
            || src.querySelector('.price__compare .price-item');
          var ctxt = cmpEl && cmpEl !== saleEl ? clean(cmpEl.textContent) : '';
          if (ctxt && ctxt !== txt) { was.textContent = ctxt; was.style.display = ''; }
          else { was.style.display = 'none'; }
        }
      };
      mirror();
      try {
        new MutationObserver(mirror).observe(src, { childList: true, subtree: true, characterData: true });
      } catch (err) { /* no-op */ }
    }

    // scroll only — never adds to cart
    bar.addEventListener('click', function (e) {
      if (!e.target.closest('.ccl-sticky__btn')) return;
      var target = anchor || document.querySelector('.ccl-buy');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ---------------------- media in custom sections ---------------------- */
  function primeMedia() {
    document.querySelectorAll('.ccl-sec video').forEach(function (v) {
      try { v.preload = 'auto'; v.load(); } catch (err) { /* no-op */ }
    });
  }

  ready(function () {
    bindCollapse();
    bindModal();
    bindShowMore();
    bindCarousel();
    document.querySelectorAll('.ccl-gallery').forEach(initGallery);
    initSticky();
    primeMedia();
  });

  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (!t) return;
    t.querySelectorAll('.ccl-gallery').forEach(initGallery);
    initSticky();
    primeMedia();
  });
})();
